import { connect } from 'react-redux';
import { getBanner, getBannerAssets, getContentfulNormalizedLocale, getError, isLoading } from '../../modules/campaign';
import { Banner } from './Banner';
const mapState = (state, ownProps) => ({
    fields: getBanner(state, ownProps.id) ?? null,
    assets: getBannerAssets(state, ownProps.id),
    isLoading: isLoading(state),
    error: getError(state),
    locale: getContentfulNormalizedLocale(state)
});
export default connect(mapState)(Banner);
//# sourceMappingURL=Banner.container.js.map